import React from 'react';

/**
 * Delad mottagarlista för e-postmodaler.
 *
 * Flera modaler skickar mail utan att visa vem det går till — man fick lita på
 * rubriken. Den här komponenten visar mottagarna och låter användaren kryssa i
 * och ur dem, med samma utseende oavsett vilken modal den sitter i.
 *
 * Mottagare: { id, name, email, role?, disabled?, selected }
 * Är `onToggle` utelämnad visas listan skrivskyddad — användbart när mottagaren
 * är given av flödet men fortfarande bör framgå.
 */
const RecipientPicker = ({
  recipients = [],
  onToggle,
  label = 'Mottagare',
  emptyText = 'Ingen mottagare hittades',
  note
}) => {
  const valbar = typeof onToggle === 'function';
  const antalValda = recipients.filter(r => r.selected).length;

  return (
    <div className="mb-4">
      <div className="flex items-baseline justify-between mb-1">
        <label className="block text-sm font-medium text-gray-700">{label}</label>
        {valbar && recipients.length > 1 && (
          <span className="text-xs text-gray-500">
            {antalValda} av {recipients.length} valda
          </span>
        )}
      </div>

      {recipients.length === 0 ? (
        <div className="border border-red-200 bg-red-50 rounded-lg px-3 py-2 text-sm text-red-700">
          {emptyText}
        </div>
      ) : (
        <div className="border border-gray-200 rounded-lg overflow-hidden">
          {recipients.map((r, index) => {
            const rad = (
              <div className={`flex items-center gap-3 px-3 py-2 ${index > 0 ? 'border-t border-gray-100' : ''}`}>
                {valbar && (
                  <input
                    type="checkbox"
                    checked={Boolean(r.selected)}
                    disabled={r.disabled}
                    onChange={() => onToggle(r.id ?? index)}
                    className="w-4 h-4 text-leadme-pink border-gray-300 rounded focus:ring-leadme-pink disabled:opacity-50"
                  />
                )}
                <div className="min-w-0">
                  <div className="text-sm text-gray-900 truncate">
                    {r.name || r.email}
                    {r.role && <span className="text-gray-500 ml-2 text-xs">({r.role})</span>}
                  </div>
                  {r.name && r.email && (
                    <div className="text-xs text-gray-500 truncate">{r.email}</div>
                  )}
                </div>
              </div>
            );

            // Hela raden klickbar när den går att välja — lättare träffyta
            return valbar && !r.disabled ? (
              <label key={r.id ?? index} className="block cursor-pointer hover:bg-gray-50 transition-colors">
                {rad}
              </label>
            ) : (
              <div key={r.id ?? index}>{rad}</div>
            );
          })}
        </div>
      )}

      {note && <p className="text-xs text-gray-500 mt-1">{note}</p>}
    </div>
  );
};

export default RecipientPicker;
